<div class="d-flex" *ngIf="displayControls && connected">
    <p class="flex-grow-1" style="font-size: 10px;">Luna vous écoute</p>

    <button mat-icon-button
            (click)="stop()">
        <i-tabler
                class="d-flex"
                name="player-stop-filled"></i-tabler>
    </button>
</div>
<audio #remoteAudio autoplay></audio>
